import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'
import { PersonalTrainerHead } from '@/index/service-category/personal-trainer/PersonalTrainerHead'
import { getRequestJSON } from 'api/index/location-api'
import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { openModal } from 'service/modal-service'
import { RequestProvider } from 'context/RequestContext'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts,
        requestCategorySettings
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      //revalidate: 86400, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings
    const router = useRouter()

    const [ requestForm, setRequestForm ] = useState(true)

    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router]) 

  return (
    <>
      <Head>
        <title>Top 10 Benefits Of Personal Training</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Why hiring a professional fitness trainer is important to see great results"/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/why-you-need-personal-trainer-singapore" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Top 10 Benefits Of Personal Training`}/>
        <meta property="og:description" content="Why hiring a professional fitness trainer is important to see great results in weight loss and muscle growth. Personal trainers can help with healthy diet plans." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-04T07:30:46+00:00" />
        <meta property="article:modified_time" content="2025-01-04T07:30:46+00:00" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness-package1.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness-package1.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/why-you-need-personal-trainer-singapore"/>
        <meta name="twitter:title" content={`Top 10 Benefits Of Personal Training`}/> 
        <meta name="twitter:description" content="Why hiring a professional fitness trainer is important to see great results in weight loss and muscle growth. Personal trainers can help with healthy diet plans."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/why-you-need-personal-trainer-singapore" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/why-you-need-personal-trainer-singapore"},"headline":"Top 10 Benefits Of Personal Training","description":"Why hiring a professional fitness trainer is important to see great results in weight loss and muscle growth. Personal trainers can help with healthy diet plans.","image":["https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/fitness-package1.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-04T07:30:46+00:00","dateModified":"2025-09-04T07:30:46+00:00"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"why-you-need-a-personal-trainer"}]}]}`
          }}
        />
      </Head>
      <div className=''>
            <RequestProvider>
                <PersonalTrainerHead 
                    heroImage={s3Static + "personal-trainer.jpg"}
                    title="Top 10 Benefits of Personal Training"
                heading="Top 10 Benefits of Personal Training"
                    intro="Affordable personal training at home, condo gym & outdoor"
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />
            </RequestProvider>
            <article className="max-w-5xl mx-auto px-2 sm:px-6 lg:px-8 py-10 space-y-16">
                <header className='space-y-6'>
                  <h2 className='text-3xl font-bold text-center'>
                      Top 10 Benefits of Personal Training
                  </h2>
                  <p className="text-lg text-gray-600 max-w-2xl mx-auto text-center">
                      Discover why hiring a professional personal trainer is key to achieving your weight loss and fitness goals. From motivation to injury prevention, here’s how they help.
                  </p>
                </header>

                {/* Benefit List */}
                <section className="space-y-16">
                  {[
                    {
                      title: '1. Individual Focus',
                      desc: 'Every person has a different fitness level, lifestyle, and goals. A personal trainer tailors a program to suit your needs, making long-term success more achievable.'
                    },
                    {
                      title: '2. Motivation',
                      desc: 'Trainers keep you accountable and provide encouragement when your motivation dips, helping you stay consistent.'
                    },
                    {
                      title: '3. Confidence',
                      desc: 'Trainers help you feel comfortable using equipment and boost your confidence in the gym—especially if you’re new.'
                    }
                  ].map(({ title, desc }) => (
                    <div key={title} className="space-y-2 px-2">
                      <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
                      <p className="text-base text-gray-700">{desc}</p>
                    </div>
                  ))}

                  {/* First Image */}
                  <motion.div
                    className="relative w-full h-80 md:h-96 mt-6 rounded-2xl overflow-hidden"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    <Image
                      src={s3Static + 'blog/health+and+fitness/man-treadmill.jpg'}
                      alt="Personal trainer helps client"
                      fill
                      style={{ objectFit: 'cover', objectPosition: 'top' }}
                      className="rounded-2xl"
                      placeholder="blur"
                      blurDataURL={s3Static + 'placeholder.png'}
                      sizes="(max-width: 768px) 100vw, 75vw"
                    />
                  </motion.div>

                  {/* Next Benefits */}
                  {[
                    {
                      title: '4. Sport-specific Training',
                      desc: 'Preparing for a 5K or hiking trip? Trainers design sport-specific routines that improve performance and reduce injury risk.'
                    },
                    {
                      title: '5. Consistency',
                      desc: 'Knowing someone’s waiting for you at the gym makes it harder to skip sessions and stick to excuses.'
                    },
                    {
                      title: '6. Prevent Injuries',
                      desc: 'Trainers teach proper form and technique, helping you avoid injuries while maximizing results.'
                    }
                  ].map(({ title, desc }) => (
                    <div key={title} className="space-y-2 px-2">
                      <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
                      <p className="text-base text-gray-700">{desc}</p>
                    </div>
                  ))}

                  {/* Second Image */}
                  <motion.div
                    className="relative w-full h-80 md:h-96 mt-6 rounded-2xl overflow-hidden"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    <Image
                      src={s3Static + 'personal-trainer/trainer-shosing-diet-plan.png'}
                      alt="Personal trainer doing diet plan consultation"
                      fill
                      style={{ objectFit: 'cover' }}
                      className="rounded-2xl"
                      placeholder="blur"
                      blurDataURL={s3Static + 'placeholder.png'}
                      sizes="(max-width: 768px) 100vw, 50vw"
                    />
                  </motion.div>

                  {/* Final Benefits */}
                  {[
                    {
                      title: '7. Clarity',
                      desc: 'A personal trainer simplifies your workout plan and removes the guesswork, ensuring every session counts.'
                    },
                    {
                      title: '8. Training With Medical Conditions',
                      desc: 'If you have diabetes, heart issues, or high blood pressure, a trainer ensures your workouts are safe and effective.'
                    },
                    {
                      title: '9. Gracefully Aging',
                      desc: 'Trainers help adjust your routine to stay strong and functional as you age, even when past methods stop working.'
                    },
                    {
                      title: '10. Fun',
                      desc: 'Trainers make exercise engaging. Group sessions or buddy workouts can make fitness enjoyable and social.'
                    }
                  ].map(({ title, desc }) => (
                    <div key={title} className="space-y-2 px-2">
                      <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
                      <p className="text-base text-gray-700">{desc}</p>
                    </div>
                  ))}
                </section>
              </article>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
      </div>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
